module.exports = __webpack_public_path__ + "img/nav__menu-benifit@3x.ac1f32dc.png";